<template>
  <div>
    <UiContentwrapper>
      <UiNarrowcolumn v-if="mounted">
        <header class="mb-2 md:mb-5 w-full flex justify-between">
          <!-- Rubriken visar titeln från den aktiva slidens artikel -->

          <h2 class="mb-2 lg:m-0">
            {{ props.headline }}
          </h2>

        </header>
        <div class="blog-slider-wrapper">
          <UCarousel
            ref="myCarousel"
            :items="techBlog.articles"
            :ui="carouselUI"
            class="blog-slider"
          >
            <template #default="{ item }">
              <div class="slide-content relative">
                <UiArticleImage v-if="item.image" :article="item" :modifiers="{
                  auto: 'format,compress',
                  crop: 'faces,edges',
                  ar: '914:475'
                }" :width="Number(914)" :height="Number(475)" sizes="100vw sm:605px md:785px lg:914px" />
                <div class="md:w-8/12">
                  <p class="large pt-4 mb-4">
                    {{ item.title }}
                  </p>
                  <p class="mt-2">
                    {{ item.content }}
                  </p>
                </div>
              </div>
            </template>
          </UCarousel>
          
          <!-- Custom navigation arrows - positioned like original vue3-carousel -->
          <div class="paginationwrapper lg:flex md:absolute -translate-y-full top-[100%] right-2">
            <div class="lg:flex-row justify-between lg:items-start">
              <div class="mt-8 flex gap-6 justify-end">
                <button 
                  @click="prevSlide" 
                  class="carousel-nav-button"
                  type="button"
                >
                  <Arrow />
                </button>
                <button 
                  @click="nextSlide" 
                  class="carousel-nav-button"
                  type="button"
                >
                  <Arrow class="rotate-180" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </UiNarrowcolumn>

    </UiContentwrapper>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useBlogStore } from '@/stores/blogStore';
import { useWindowSize } from '@vueuse/core'

const blogStore = useBlogStore();
const mounted = ref(false);
const myCarousel = ref(null);
const techBlog = ref(null);

const { width } = useWindowSize()

const isMobile = computed(() => width.value < 800)


// Definiera props
const props = defineProps({
  slug: {
    type: String,
    default: 'tech-slides'
  },
  headline: {
    type: String,
    default: 'Tech Slides'
  }
});

// UI configuration for UCarousel - basis controls the peek effect
// Gap value is coordinated with slide content styling
const CAROUSEL_GAP = 'gap-10'; // 2.5rem

const carouselUI = computed(() => ({
  item: isMobile.value ? 'basis-full' : 'basis-2/3',
  container: CAROUSEL_GAP
}));

// Navigation methods for external buttons using Embla's scrollPrev/scrollNext API
const prevSlide = () => {
  if (myCarousel.value) {
    myCarousel.value.emblaApi?.scrollPrev();
  }
};

const nextSlide = () => {
  if (myCarousel.value) {
    myCarousel.value.emblaApi?.scrollNext();
  }
};

onMounted(async () => {

  try {
    techBlog.value = await blogStore.fetchBlogByHandle(props.slug);
    mounted.value = true;
  }
  catch (err) {
    console.error('Error fetching slides data:', err);
  }


});

</script>

<style scoped>
.blog-slider-wrapper {
  position: relative;
}

.carousel-nav-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
}

.carousel-nav-button:disabled {
  cursor: not-allowed;
}
</style>